module.exports = __webpack_public_path__ + "static/Mavia-6b7402f1566d615f0e79c6f0413db13b.png";